// Gitbook Space ID
const SPACE_IDS_MAP = {
  WORLD_OF_GLENCOCO: "f5LkmcT8D3Tt8FlyON5s",
};

export const getDocsPath = (
  path: string,
  spaceId: string = SPACE_IDS_MAP.WORLD_OF_GLENCOCO
) => ({
  spaceId,
  path,
});

/**
 * @description Maps the app routes to the Gitbook documentation paths.
 */
export const DocsRouter = {
  home: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/home/user.glencoco.com-dashboard"
    ),
  dashboard: () => getDocsPath("the-cast-of-players%2Fcaller"),

  lists: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/leads/user.glencoco.com-lists"
    ),
  coldLeads: () => getDocsPath("core-concepts/lead-statuses/cold-leads"),
  nurtureLeads: () => getDocsPath("core-concepts/lead-statuses/nurture-leads"),
  pullFromLeadPool: () =>
    getDocsPath("core-concepts/lead-pools/pulling-leads-from-the-lead-pool"),

  listsSorting: () => getDocsPath("core-concepts/dialing/lists/sorting"),
  listsFiltering: () => getDocsPath("core-concepts/dialing/lists/filtering"),

  listsProspectName: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/prospect-name"),
  listsDials: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/dials"),
  listsLastDialed: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/last-dialed"),
  listsTitle: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/title"),
  listsConversations: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/conversations"),
  listsLastConversation: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/last-conversation"),
  listsCooldown: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/cooldown"),
  listsAccountName: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/account-name"),
  listsTimezone: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/timezone"),
  listsLastDisposition: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/last-disposition"),
  listsAccountStatus: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/account-status"),
  listsMeetingOutcome: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/meeting-outcome"),
  listsAccountDQReason: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/account-dq-reason"),
  listsContactType: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/contact-type"),
  listsNextTouchTime: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/next-touch-time"),
  listsAccountSummary: () =>
    getDocsPath("core-concepts/dialing/lists/list-columns/account-summary"),

  history: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/leads/user.glencoco.com-history"
    ),

  performance: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/performance/user.glencoco.com-performance"
    ),
  performanceTimeOnDialer: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/performance/user.glencoco.com-performance/time-on-dialer"
    ),
  performanceCallBreakdowns: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/performance/user.glencoco.com-performance/call-breakdowns"
    ),
  performanceMeetingBreakdowns: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/performance/user.glencoco.com-performance/meeting-breakdowns"
    ),

  leaderboard: () => getDocsPath("core-concepts/incentives/weekly-leaderboard"),

  messages: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/messages/user.glencoco.com-messages"
    ),
  emailInbox: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/messages/user.glencoco.com-email-inbox"
    ),

  myCampaigns: () => getDocsPath("core-concepts/campaigns/glencoco-campaigns"),
  campaignsDiscover: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/campaigns/user.glencoco.com-discover"
    ),

  profile: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/settings/user.glencoco.com-settings/user.glencoco.com-settings-profile"
    ),
  callForwarding: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/settings/user.glencoco.com-settings/user.glencoco.com-settings-call-forwarding"
    ),
  payouts: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/settings/user.glencoco.com-settings/user.glencoco.com-settings-payouts"
    ),
  referrals: () =>
    getDocsPath(
      "key-locations/key-locations-for-callers/user.glencoco.com/settings/user.glencoco.com-settings/user.glencoco.com-settings-referrals"
    ),
};
